import React from "react";
import Image from "next/image";

const Crisis = () => {
  return (
    <>
      <div className="w-full pt-6 pb-10 bg-[#061A2F] px-4">
        <div className="text-center">
          <h2 className="text-[20px] relative lg:text-[40px] md:text-[38px] lg:leading-[3.5rem] md:leading-[3rem] leading-[1.8rem] text-white  font-semibold text-center inline-block mx-auto px-[4px]">
            <span className="border-[#ca7216] border-b-2 inline-block">
              The US is Facing a Severe <br /> Healthcare Talent Crisis
            </span>
            <Image
              src="/healthcare/home/str.svg"
              alt="CPA Recruiting firms"
              className="absolute top-0 -left-4 rotate-180 scale-x-[-1]"
              width={12}
              height={12}
            />
          </h2>
        </div>
        <div className="border-[#FFA548] border-[1px] bg-white py-3 px-3 text-center rounded-[14px] mt-8">
          <h3 className="text-[20px] font-bold pb-2 border-b-[1px] border-[#D8D8D8]">
            Nurse Shortage
          </h3>
          <p className="font-medium text-[16px] text-[#2F2F2F] pt-2">
            As 80% of nurses are set to retire in two
            <br /> decades, the healthcare sector must
            <br /> brace for a significant workforce
            <br /> shortage.
          </p>
        </div>
        <div className="border-[#FFA548] border-[1px] bg-white py-3 px-3 text-center rounded-[14px] mt-4">
          <h3 className="text-[20px] font-bold pb-2 border-b-[1px] border-[#D8D8D8]">
            Doctor Shortage
          </h3>
          <p className="font-medium text-[16px] text-[#2F2F2F] pt-2">
            The US healthcare system could face a deficit of 48,000 primary care
            doctors
            <br /> and 77,000 specialists by 2034, risking
            <br /> patient care delays.
          </p>
        </div>
      </div>
    </>
  );
};
export default Crisis;
